import * as yup from 'yup';

export const nullSchema = yup.object().shape({}).nullable(true);

export const licenceConditionsSchema = nullSchema;
